import Screen from './view'

export default Screen
